import information from './information';
import errorPage from "./error-page";
import home from "./home";
import lifeNav from "./life-nav";
import industry from "./industry";
import grow from "./grow";
import ecosystem from "./ecosystem";
import newecosystem from "./newecosystem";
import students from "./students";
import broadcast from "./broadcast";


import richdoor from "./rich-door";
import branchschool from "./branch_school";
import lifeDriver from "./life-driver";
import benefitactivity from './benefit-activity';
import disease from './disease';
import microvision from './micro-vision';
import fuwuinfo from './fuwu-info';


//一级挂载的路由
const routes = [
  home,       //首页
  information, // 资讯
  industry,   //产业链
  grow,       //成长系统
  ecosystem,  //生态圈
  newecosystem,  //生态圈-新 /科技新生活
  lifeNav,    //生活导航
  students,    //学员后台
	broadcast,   //直播
  errorPage,   //错误页

//  新版生命驾校
  richdoor, //五本财富
  branchschool, //申请驾校
  lifeDriver, //生命驾照
  benefitactivity,// 公益活动
  disease, //疾病一点通
  microvision,//微视
  fuwuinfo,//服务通——素食资讯


  //demo测试用页面
  {
    path: '/demo',
    name: 'demo',
    component:  () => import ('@/views/demo/demo'),
    meta: {tabBar: false}
  },
  //demo测试用页面
  {
    path: '/my_demo',
    name: 'my_demo',
    component:  () => import ('@/views/demo/my_demo'),
    meta: {tabBar: false}
  }
];

export default routes;
